<template>
  <v-menu :left="left" offset-y open-on-hover :top="top">
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on" :class="`${textColor}--text`">
        <div v-if="isIcon">
          <slot name="icon"> {{ title }}</slot>
        </div>
        <div v-else>
          <u>
            <slot name="title"> {{ title }}</slot>
          </u>
        </div>
      </div>
    </template>
    <v-list v-bind:style="{ width: width }">
      <v-list-item>
        <v-list-item-content> <slot /> </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  components: {
    //
  },
  props: {
    title: { default: '' },
    textColor: { default: 'black' },
    width: { default: '' },
    left: { default: true },
    isIcon: { default: false },
    top: { default: false }
  },
  data: () => ({
    //
  })
}
</script>
<style scoped lang="scss"></style>
